import React, { useState } from 'react';
import styles from '../css/Nav.module.css'
import { Logout, AccountCircle } from '@mui/icons-material';
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { AppBar, List, ListItem, ListItemText, Menu } from "@mui/material";
import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { commonActions } from "reducers/common";
import { authClear } from "../../service/util/authClear";
import instance from "../../Http-common";

const TopNav = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const drawerOpen = useSelector(state => state.commonData.drawerOpen);
    const user = useSelector(state => state.commonData.user);

    const [anchorEl, setAnchorEl] = useState(null);
    const openMyInfo = Boolean(anchorEl);

    const handleOpenMyInfo = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMyInfo = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        Swal.fire({
            text: '로그아웃 하시겠습니까?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(commonActions.setLogout());
                authClear();
                delete instance.defaults.headers.common['Authorization'];
                history.push('/login');
            } else return false;
        })
    }
    return (
        <AppBar sx={{ background: "#231f1f !important" }} position="fixed" open={drawerOpen}>
            <Toolbar>
                <div className={styles.topNavWrap}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => dispatch(commonActions.handleDrawerOpen())}
                        edge="start"
                        sx={{
                            marginRight: 5,
                            ...(drawerOpen && { display: 'none' }),
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                </div>
                <div className={styles.topBox}>
                    <div className={styles.userInfo}>
                        <IconButton
                            id="basic-button"
                            edge="end"
                            color="inherit"
                            onClick={(e) => handleOpenMyInfo(e)}
                        >
                            <AccountCircle />
                        </IconButton>
                        {user !== null &&
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={openMyInfo}
                                onClose={handleCloseMyInfo}
                            >
                                <List>
                                    <ListItem>
                                        <ListItemText
                                            primary={"사용자 아이디"}
                                            secondary={user?.username || ''}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText
                                            primary={"사용자 이름"}
                                            secondary={user?.name || ''}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText
                                            primary={"사용자 권한"}
                                            secondary={user?.role.name || ''}
                                        />
                                    </ListItem>
                                </List>
                            </Menu>
                        }
                    </div>
                    <button onClick={handleLogout}><Logout /></button>
                </div>
            </Toolbar>
        </AppBar>
    );
};

export default TopNav;